import React from 'react';
import { dealLockHooks } from '../hooks';

import CommonModal from './components/CommonModal.interstate';

const Modal: React.FC = () => {
    const {
        isLocked,
        dialog: { title, message }
    } = dealLockHooks.useDealFinalizationLocking();

    return <>{isLocked && <CommonModal title={title} message={message} dataTestId="deal-finalized-modal" />}</>;
};

export default Modal;
